import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormComponent } from 'ngx-schema-form';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  constructor(public auth: AuthService, private router: Router) {
  }
  phoneGroup = new FormGroup({
    phone: new FormControl('+7')
  });
  authGroup = new FormGroup({
    token: new FormControl(''),
    code: new FormControl('')
  });
  emailGroup = new FormGroup({
    email: new FormControl('')
  });
  ngOnInit(): void {
  }
  getCode() {
    this.auth.signInWithWB(this.phoneGroup.value);
    //this.auth.getTokenByPhone(this.phoneGroup.value);
  }
  goMail() {
    this.auth.signInWithEmail(this.emailGroup.value);
    //this.auth.getTokenByPhone(this.phoneGroup.value);
  }
  backward() {
    this.auth.removeToken();
  }
  signWB() {
    this.authGroup.patchValue({
      token: this.auth.token
    })
    this.auth.authWBPassport(this.authGroup.value);
  }
  

}
